import { render } from "./EditLinkedTransaction.vue?vue&type=template&id=1f9b19e0&scoped=true"
import script from "./EditLinkedTransaction.vue?vue&type=script&lang=js"
export * from "./EditLinkedTransaction.vue?vue&type=script&lang=js"

import "./EditLinkedTransaction.vue?vue&type=style&index=0&id=1f9b19e0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f9b19e0"]])

export default __exports__